module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    ref: "editorElement"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f423b14e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/sunEditor.vue
// module id = 2318
// module chunks = 0